// This file was automatically generated from app.settings.letterRouting.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.letterRouting');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.letterRouting.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">Patient Passport Messages</h1><div class="mb30" id="passport-messages-toggle-section"><div class="ebs-clearfix"><div class="el8ToggleContainer ebs-pull-right ml20"><input type="radio" name="passportMessagesEnabled" value="true" id="passport-messages-enabled-true" class="el8Toggle el8ToggleTrue" /><label for="passport-messages-enabled-true" class="el8ToggleLabel el8ToggleLabelOn">Yes</label><input type="radio" name="passportMessagesEnabled" value="false" id="passport-messages-enabled-false" class="el8Toggle el8ToggleFalse" /><label for="passport-messages-enabled-false" class="el8ToggleLabel el8ToggleLabelOff">No</label><span class="el8ToggleSelection"></span></div><div class="ebs-row"><div class="ebs-col-xs-9"><div class="padt6 el8Bold">Allow patients to send messages to the practice</div><p class="ebs-text-muted padt3">If disabled, patients will still be able to respond to letters that your practice sends to their Passport.</p></div></div></div><div class="confirm-msg ebs-pull-right ebs-text-right mt5 el8StandardFontSize el8Bold"></div></div><div class=\'routing-ui-container\' style="display: none"><div class="passport-messages-about-section mb30"><p class="el8MessageContainer ebs-alert ebs-alert-info"><span class="el8Bold el8Block mb5">What is message routing?</span>When a patient message is <span class="el8Bold">routed</span> to a person or group, that message will show up in their Practice Home queue(s).</p></div><div class="bulk-customization-section mb30"><h3 class="el8SectionHeader">Routing for All Providers</h3><div>You can update routing for all providers in your practice in one step here: <a class="el8Link ml5" id="update-for-all-trigger">Update Routing for All Providers</a></div><div class="bulk-edit-form-div" style="display: none"><form class="bulk-edit-form"><div class="el8MessageRoutingForm el8EditRouting mt20"><h4 class="noBorder el8Bold">Update Routing for All Providers</h4><div>Use this form to make routing changes for every provider at once.</div><div class="mv10 el8Bold el8Red">Leave the "Route To" field empty for each category that you do not wish to change.</div><ul class="el8SettingsTable ebs-list-unstyled">');
  el8.template.app.settings.letterRouting.tableHeader(null, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Appointments', listId: 'all-appointment-recip-list', inputName: 'appointment-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Referrals', listId: 'all-referral-recip-list', inputName: 'referral-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Prescriptions & Refills', listId: 'all-rx-and-refill-recip-list', inputName: 'rx-and-refill-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Lab or Other Test Results', listId: 'all-labs-and-tests-recip-list', inputName: 'labs-and-tests-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'General Inquiries', listId: 'all-staff-question-recip-list', inputName: 'staff-question-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Question About My Health', listId: 'all-health-question-recip-list', inputName: 'health-question-recip'}, output);
  output.append('</ul> <!-- table --><div class="bulk-edit-form-buttons"></div></div></form></div></div><div class="provider-customization-section mb30"><h3 class="el8SectionHeader">Routing Per Provider</h3><p>Use this section to view and edit how incoming Passport messages from patients of each provider will be routed in the practice.</p>');
  var objList7103 = opt_data.routesByProvider;
  var objListLen7103 = objList7103.length;
  for (var objIndex7103 = 0; objIndex7103 < objListLen7103; objIndex7103++) {
    var objData7103 = objList7103[objIndex7103];
    el8.template.app.settings.letterRouting.roProvider({obj: objData7103}, output);
    el8.template.app.settings.letterRouting.editProvider({obj: objData7103}, output);
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.letterRouting.roProvider = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="div-provider-', soy.$$escapeHtml(opt_data.obj.id), '" class="el8MessageRoutingForm mt20"><h4 class="el8Bold mb10 noBorder">', soy.$$escapeHtml(opt_data.obj.fullName), '<a class="edit-provider-trigger el8Link ebs-pull-right" data-id="', soy.$$escapeHtml(opt_data.obj.id), '">Change Routing for ', soy.$$escapeHtml(opt_data.obj.fullName), '</a></h4><ul class="el8SettingsTable ebs-list-unstyled">');
  el8.template.app.settings.letterRouting.tableHeader(null, output);
  var ruleList7121 = opt_data.obj.rules;
  var ruleListLen7121 = ruleList7121.length;
  for (var ruleIndex7121 = 0; ruleIndex7121 < ruleListLen7121; ruleIndex7121++) {
    var ruleData7121 = ruleList7121[ruleIndex7121];
    el8.template.app.settings.letterRouting.roCategory({rule: ruleData7121}, output);
  }
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.letterRouting.editProvider = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="edit-form-provider-', soy.$$escapeHtml(opt_data.obj.id), '" style="display: none"><div class="el8MessageRoutingForm el8EditRouting mt20"><h4 class="el8Bold mb10 noBorder">', soy.$$escapeHtml(opt_data.obj.fullName), '</h4><ul class="el8SettingsTable ebs-list-unstyled">');
  el8.template.app.settings.letterRouting.tableHeader(null, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Appointments', listId: 'appointment-recip-list', inputName: 'appointment-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Referrals', listId: 'referral-recip-list', inputName: 'referral-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Prescriptions & Refills', listId: 'rx-and-refill-recip-list', inputName: 'rx-and-refill-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Lab or Other Test Results', listId: 'labs-and-tests-recip-list', inputName: 'labs-and-tests-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'General Inquiries', listId: 'staff-question-recip-list', inputName: 'staff-question-recip'}, output);
  el8.template.app.settings.letterRouting.editCategory({categoryName: 'Question About My Health', listId: 'health-question-recip-list', inputName: 'health-question-recip'}, output);
  output.append('</ul><div id="edit-form-provider-buttons-', soy.$$escapeHtml(opt_data.obj.id), '"></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.letterRouting.roCategory = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8SettingsTableRow"><div class="w40 el8SettingsTableCell"><p class="pad10 el8Bold">', soy.$$escapeHtml(opt_data.rule.prettyCategory), '</p></div><div class="w60 el8SettingsTableCell"><p class="pad10">');
  var nameList7164 = opt_data.rule.userAndGroupNames;
  var nameListLen7164 = nameList7164.length;
  for (var nameIndex7164 = 0; nameIndex7164 < nameListLen7164; nameIndex7164++) {
    var nameData7164 = nameList7164[nameIndex7164];
    output.append((! (nameIndex7164 == 0)) ? '; ' : '', soy.$$escapeHtml(nameData7164));
  }
  output.append('</p></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.letterRouting.editCategory = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8SettingsTableRow"><div class="w40 el8SettingsTableCell"><p class="pad10 el8Bold">', soy.$$escapeHtml(opt_data.categoryName), '</p></div><div class="w60 el8SettingsTableCell"><div class="pad10"><ul id="', soy.$$escapeHtml(opt_data.listId), '" class="ebs-list-unstyled"></ul><div><input type="text" class="ebs-form-control" name="', soy.$$escapeHtml(opt_data.inputName), '" /></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.letterRouting.tableHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8SettingsTableHeader ebs-clearfix"><div class="w40 ebs-pull-left"><div class="el8StrongMiniHeading pad10 el8CoolGray">Message Category</div></div><div class="w60 ebs-pull-left"><div class="el8StrongMiniHeading pad10 el8CoolGray">Route To:</div></div></li>');
  if (!opt_sb) return output.toString();
};
